export default __webpack_public_path__ + "static/inline-edit-dont-ce019b35e67efb34c28653b62c0de409.png";